module.exports = __webpack_public_path__ + "static/media/rede-pocante.a8e2f518.png";